import {
  CLEAR_FILTER,
  SET_CAT_FILTER,
  SET_FILTER,
  SET_LEVEL_FILTER,
  SET_LOCATION_FILTER,
  SET_SALARY_FILTER,
  SET_TEXT_FILTER,
  SET_TOOLS,
} from "../constants";

const setFilter = (filter = []) => ({
  type: SET_FILTER,
  filter,
});

const setText = (text = "") => ({
  type: SET_TEXT_FILTER,
  text,
});

const setCategory = (category = "") => ({
  type: SET_CAT_FILTER,
  category,
});

const setLevel = (level = "") => ({
  type: SET_LEVEL_FILTER,
  level,
});

const setLocation = (location = "") => ({
  type: SET_LOCATION_FILTER,
  location,
});

const setSalary = (salary = "") => ({
  type: SET_SALARY_FILTER,
  salary,
});

const setTools = (tools = "") => ({
  type: SET_TOOLS,
  tools,
});

const clearAll = () => () => ({
  type: CLEAR_FILTER,
});

const actions = {
  setFilter,
  setText,
  setCategory,
  setLevel,
  setTools,
  setLocation,
  setSalary,
  clearAll,
};

export default actions;
